module.exports = __webpack_public_path__ + "img/qrcode-no-img.d6b7a005.png";